export const locale = {
    lang: 'en',
    data: {
        'NAV': {
            'APPLICATIONS': 'Applications',
            'SAMPLE'        : {
                'TITLE': 'Sample',
                'BADGE': '25'
            },
            'FINANCE': 'Finanzas',
            'LOAN': 'Prestamos',
            'LOANLIST': 'Lista de Prestamos',
            'SHARED': 'Finanzas',
            'ACCOUNTS': {
                'TITLE': 'Cuentas'
            },
            'CATEGORY-ACCOUNTS': 'Categorías de Cuentas',
            'CATEGORY-EXPENSES': 'Categorías de Cuentas',
            'TRACKING-SPEND': 'Registros de Gastos'
        }
    }
};
